<template>
    <svg viewBox="0 0 1920.725 1080"  v-if="!isMobile" class="dflt-hex">
         <defs>
            <radialGradient id="a" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#0076b0"/><stop offset="1" stop-color="#003b58" stop-opacity="0"/>
            </radialGradient>

            <radialGradient id="b" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#00f4ff"/><stop offset="1" stop-color="#007a80" stop-opacity="0"/>
            </radialGradient>
            <radialGradient id="c" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#0076b0"/><stop offset="0.569" stop-color="#004364" stop-opacity="0"/>
                <stop offset="1" stop-color="#003b58" stop-opacity="0"/>
            </radialGradient>
            <g id="blue-light">
                <ellipse cx="20.225" cy="23.861" rx="20.225" ry="23.861" transform="translate(193.568 174.299) rotate(180)" fill="url(#a)"/>
                <ellipse cx="36.263" cy="36.263" rx="50" ry="50" transform="translate(209.527 187.015) rotate(180)" fill="url(#b)"/>
                <path d="M0,1.881c1.926.166,5.188.319,9.647.459,12.522.394,34.32.648,59.093.633,39.065-.024,70.733-.709,70.732-1.53S107.8-.023,68.739,0C35.443.021,7.521.522,0,1.177Z" transform="translate(121.546 92.508) rotate(45)" opacity="0.82" fill="url(#c)" style="mix-blend-mode:color-dodge;isolation:isolate"/>
                <path d="M0,1.566c1.6.138,4.319.266,8.031.382,10.425.328,28.571.539,49.194.527,32.521-.02,58.884-.59,58.884-1.273S89.745-.02,57.224,0C29.506.017,6.261.434,0,.98Z" transform="matrix(-0.743, 0.669, -0.669, -0.743, 217.128, 107.122)" opacity="0.82" fill="url(#c)" style="mix-blend-mode:color-dodge;isolation:isolate"/>
            </g>
         </defs>
        <g class="lights">
            <rect width="1920" height="1080" transform="translate(0 0)" fill="#1d1d1e"/> 
            <use  class="item" v-for="item in lightPosPc" :key="item" :transform="'translate('+item+')'" xlink:href="#blue-light"/>
        </g>
    </svg>
     <svg viewBox="0 0 450 530" v-else class="mob-hex1">
        <defs>
            <radialGradient id="radial-gradient" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00f4ff"/><stop offset="1" stop-color="#007a80" stop-opacity="0"/></radialGradient>
            <radialGradient id="radial-gradient-2" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#0076b0"/><stop offset="0.569" stop-color="#004364" stop-opacity="0"/><stop offset="1" stop-color="#003b58" stop-opacity="0"/></radialGradient>
            <radialGradient id="radial-gradient-5" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#0076b0"/><stop offset="1" stop-color="#003b58" stop-opacity="0"/></radialGradient>
             <g id="light-sm" data-name="light" transform="">
                <ellipse id="Glow-2" data-name="Glow" cx="24.846" cy="22.392" rx="24.846" ry="22.392" transform="translate(59.017 58.954) rotate(180)" fill="url(#radial-gradient)" style="mix-blend-mode: color-dodge;isolation: isolate"/>
                <path id="Path_1936-2" data-name="Path 1936" d="M0,1.721c3.771.591,17.772,1.018,34.467,1,19.587-.022,35.466-.648,35.466-1.4S54.053-.021,34.466,0C17.771.019,3.771.477,0,1.077Z" transform="translate(69.932 39.567) rotate(180)" opacity="0.82" fill="url(#radial-gradient-2)" style="mix-blend-mode: color-dodge;isolation: isolate"/>
                <path id="Path_1937-2" data-name="Path 1937" d="M0,.629C.644.684,1.735.736,3.226.783,7.414.914,14.7,1,22.988.994,36.052.986,46.642.757,46.642.483S36.051-.008,22.987,0C11.853.007,2.515.174,0,.394Z" transform="translate(46.971 16.439) rotate(120)" opacity="0.82" fill="url(#radial-gradient-2)" style="mix-blend-mode: color-dodge;isolation: isolate"/>
                <path id="Path_1944-2" data-name="Path 1944" d="M0,1.723c4.289.591,20.212,1.017,39.2,1,22.277-.023,40.336-.651,40.336-1.4S61.476-.023,39.2,0C20.212.02,4.289.479,0,1.079Z" transform="translate(51.333 70.241) rotate(-120)" opacity="0.82" fill="url(#radial-gradient-2)" style="mix-blend-mode: color-dodge;isolation: isolate"/>
                <ellipse id="Ellipse_79-2" data-name="Ellipse 79" cx="14.016" cy="14.017" rx="14.016" ry="14.017" transform="translate(48.24 50.367) rotate(180)" fill="url(#radial-gradient-5)" style="mix-blend-mode: color-dodge;isolation: isolate"/>
            </g>
        </defs>
        <g class="lights" transform="translate(0 3.991)" style="isolation: isolate">
            <rect id="Rectangle_1" data-name="Rectangle 1" width="450" height="530" transform="translate(0 -3.991)" fill="none"/>
             <use  class="item" v-for="item in lightPosMob" :key="item" :transform="'translate('+item+') rotate(-92)'" xlink:href="#light-sm"/>
        </g>
    </svg>
    
</template>
<style scoped>
.mob-hex1 .lights .item{ animation: fade infinite ease-in-out; -webkit-animation: fade infinite ease-in-out;}
.mob-hex1 .lights .item:nth-child(2){ animation-duration: 2s}
.mob-hex1 .lights .item:nth-child(3){ animation-duration: 2.3s}
.mob-hex1 .lights .item:nth-child(4){ animation-duration: 2.6s}
.mob-hex1 .lights .item:nth-child(5){ animation-duration: 2.1s}
.mob-hex1 .lights .item:nth-child(6){ animation-duration: 2.5s}
.mob-hex1 .lights .item:nth-child(7){ animation-duration: 2.8s}
.mob-hex1 .lights .item:nth-child(8){ animation-duration: 2.9s}
.mob-hex1 .lights .item:nth-child(9){ animation-duration: 3s}
.mob-hex1 .lights .item:nth-child(10){ animation-duration: 3.2s}
.mob-hex1 .lights .item:nth-child(11){ animation-duration: 2.2s}
.mob-hex1 .lights .item:nth-child(12){ animation-duration: 2.4s}
.mob-hex1 .lights .item:nth-child(13){ animation-duration: 2.7s}
.mob-hex1 .lights .item:nth-child(14){ animation-duration: 3.1s}
.mob-hex1 .lights .item:nth-child(15){ animation-duration: 1.9  s}

.dflt-hex .lights .item:nth-child(110),
.dflt-hex .lights .item:nth-child(95),
.dflt-hex .lights .item:nth-child(62),
.dflt-hex .lights .item:nth-child(34),
.dflt-hex .lights .item:nth-child(23),
.dflt-hex .lights .item:nth-child(17),
.dflt-hex .lights .item:nth-child(117),
.dflt-hex .lights .item:nth-child(109),
.dflt-hex .lights .item:nth-child(52),
.dflt-hex .lights .item:nth-child(47),
.dflt-hex .lights .item:nth-child(4),
.dflt-hex .lights .item:nth-child(10)
{
    animation: fade infinite;
    -webkit-animation: fade infinite;
}

.dflt-hex .lights .item:nth-child(110){ animation-duration: 3s}
.dflt-hex .lights .item:nth-child(95){ animation-duration: 2s}
.dflt-hex .lights .item:nth-child(62){ animation-duration: 2.3s}
.dflt-hex .lights .item:nth-child(34){ animation-duration: 2.8s}
.dflt-hex .lights .item:nth-child(23){ animation-duration: 1.8s}
.dflt-hex .lights .item:nth-child(17){ animation-duration: 2.1s}
.dflt-hex .lights .item:nth-child(117){ animation-duration: 3.2s}
.dflt-hex .lights .item:nth-child(109){ animation-duration: 2.5s}
.dflt-hex .lights .item:nth-child(52){ animation-duration: 2.4s}
.dflt-hex .lights .item:nth-child(47){ animation-duration: 2.6s}
.dflt-hex .lights .item:nth-child(4){ animation-duration: 3.3s}
.dflt-hex .lights .item:nth-child(10){ animation-duration: 2.9s}
@media (max-width: 768px) {
    .svghex-s1-d{
        display: none !important;
    }
    .mob-hex1{
        height: auto !important;
        width: 120% !important;
        left: -10% !important;
    }
}
@media (max-width: 480px) {
    .mob-hex1{
        width: 150% !important;
        left: -25% !important;
    }
}

</style>
<script>
import helpers from '@/plugins/helpers' 
export default {
  data() {
    return {
        lightPosPc:["467.234 746.985","360.234 745.985","1535.234 747.985","1536.234 809.985","1696.234 655.985","1428.234 747.985","734.234 715.985","948.234 715.985",
        "1055.234 714.985","1162.234 714.985","1213.234 809.985","1107.234 805.985","841.234 842.985","413.234 839.985","1322.234 746.985","307.234 653.985",
        "200.234 654.985","1375.234 653.985","1482.234 655.985","1589.234 655.985","1268.234 655.985","-120.766 654.985","40.234 561.985","147.234 561.985",
        "254.234 561.985","1429.234 561.985","1536.234 562.985","1643.234 562.985","1322.234 562.985","-66.766 561.985","-12.766 468.985","94.234 468.985",
        "201.234 468.985","1376.234 468.985","1483.234 469.985","1590.234 469.985","1697.234 469.985","-119.766 468.985","-65.766 375.985","41.234 375.985",
        "148.234 376.985","255.234 374.985","1324.234 375.985","1430.234 376.985","1536.234 377.985","1643.234 377.985","-12.766 283.985","94.234 282.985",
        "202.234 283.985","309.234 282.985","1271.234 284.985","1377.234 283.985","1484.234 284.985","1590.234 285.985","1697.234 284.985","-119.766 282.985",
        "-64.766 190.985","42.234 190.985","148.234 190.985","256.234 190.985","363.234 190.985","470.234 189.985","577.234 189.985","683.234 189.985",
        "791.234 189.985","896.234 189.985","1003.234 189.985","1111.234 190.985","1218.234 189.985","1325.234 190.985","1431.234 190.985","1538.234 190.985",
        "1644.234 191.985","-11.766 97.985","95.234 97.985","202.234 97.985","309.234 97.985","416.234 97.985","523.234 97.985","630.234 96.985","737.234 97.985",
        "844.234 97.985","952.234 97.985","1059.234 97.985","1166.234 96.985","1271.234 98.985","1378.234 98.985","1485.234 98.985","1591.234 99.985",
        "1699.234 98.985","-117.766 96.985","-63.766 4.985","43.234 5.985","257.234 5.985","470.234 5.985","683.234 5.985","896.234 5.985","1110.234 4.985",
        "1325.234 6.985","147.234 4.985","1538.234 6.985","364.234 5.985","577.234 5.985","791.234 5.985","1003.234 5.985","1218.234 5.985","1432.234 6.985",
        "1645.234 6.985","-7.766 -87.015","96.234 -86.015","203.234 -87.015","310.234 -87.015","417.234 -87.015","524.234 -87.015","630.234 -87.015","737.234 -86.015",
        "844.234 -86.015","952.234 -86.015","1059.234 -86.015","1166.234 -87.015","1272.234 -87.015","1378.234 -86.015","1485.234 -85.015","1592.234 -85.015",
        "1699.234 -85.015","-117.766 -87.015"],
        isMobile:helpers.isMobile(),
        lightPosMob:["59.44 140.111", "246.44 95.111", "321.44 140.111", "321.44 140.111", "321.44 74.111","77.44 495.111","304.44 495.111","246.44 206.111",
        "57.44 204.111","153.44 238.111","114.44 107.111","171.44 78.111","171.44 141.111","58.441 75.111"]
    }
 },
  mounted: function () {
    var self =this;
    self.onLoadAnim()
    self.onMouseOver()
  },
  methods: {
    onLoadAnim: function(){
        if(!this.isMobile){
            
            // var lightsPos = [127,125,101,100, 96, 70,72, 75, 60 ,51, 31 ,35,19]
            // lightsPos.forEach(pos => {
            // document.querySelector('.lights .item:nth-child('+pos+')').classList.add('on')
                
            // });
            
        }else{

        }
    },
    onMouseOver:function(){
        // document.querySelector('.lights').addEventListener("mouseover",function(e) {
        //     e.target.classList.add('on');
        // // console.log(Array.prototype.indexOf.call(e.target.parentNode.children, e.target) )
        // setTimeout(() => {e.target.classList.remove('on');}, 2000)} )
    }
  }
}
</script>